import { create } from 'zustand';
import { UserRole } from './draft.input';

export interface PublisherInputState {
  role: UserRole;
  userAllowed: boolean | null;
}

interface WhitelistAction {
  setValue<K extends keyof PublisherInputState>(
    key: K,
    value: PublisherInputState[K],
  ): void;
  clear(): void;
}

type whitelistStoreType = PublisherInputState & WhitelistAction;

export const usePublisherInputStore = create<whitelistStoreType>((set) => ({
  userAllowed: null,
  role: 'publisher-portal',
  setValue(key, value) {
    set((state) => ({
      [key]: value,
    }));
  },
  clear: () => {
    set((state) => ({ role: null, userAllowed: null }));
  },
}));
